var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.followedPrograms
    ? _c(
        "li",
        {
          staticClass: "c-navbar__menu-item",
          class: _vm.isPage("programs") ? "c-navbar__menu-item--active" : "",
        },
        [
          _c(
            "a",
            {
              staticClass: "c-navbar__menu-link",
              class: _vm.submenuLinkClass,
              attrs: { href: "#/programs" },
            },
            [
              _c("span", { staticClass: "c-navbar__menu-link-text" }, [
                _vm._v("Programs"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "nav",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              staticClass: "c-navbar__submenu",
              class: _vm.submenuClass,
            },
            [
              _c(
                "ul",
                { staticClass: "c-navbar__menu-list" },
                _vm._l(_vm.followedPrograms, function (program, index) {
                  return _c(
                    "li",
                    {
                      key: "followed-program-" + index,
                      staticClass: "c-navbar__menu-item",
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "c-navbar__menu-link c-navbar__menu-link-program",
                          attrs: {
                            to: {
                              name: "Program",
                              params: { uuid: program.uuid },
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "c-navbar__menu-link-text" },
                            [_vm._v(_vm._s(program.title))]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }